import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {EmployeeActivateComponent} from './components/employee-activate.component';

const routes = [
  {
    path: 'employeeactivate',
    component: EmployeeActivateComponent,
    children: [
      {
        path: ':key',
        component: EmployeeActivateComponent,
      }]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EmployeeActivateRoutingModule { }
